package org.vreo.devicehub.features.core.domain.device.vrmConfig

import org.vreo.devicehub.features.vrmOutput.domain.models.VrmOverlayerPosition

/**
 * Vrm output config
 *
 * @property id instance identifier
 * @property enabled enable or disable VRM output
 * @property vrmType type of VRM output
 * @property endpoint VRM endpoint URL
 * @property apiKey API key for authentication, provides access to target VRM endpoint
 * @property siteId site id (parking lot id)
 * @property useRoiId if true, link VRM to dedicated ROI via identifier. Identifier is set via 'bayIdentifier'
 * @property bayIdentifier bay identifier
 * @property confidenceThreshold minimum threshold for message to be sent to VRM
 * @property timeoutSeconds VRM access timeout in seconds
 * @property verifySsl verify ssl
 * @property enableOverlayer enables or disables overlayer of vrm and ocr metadata on the ocr images
 * @property overlayerPosition position of the overlayer on the image
 * @property overlayerLabel custom label/tag to be added to the overlayer
 * @property enableOverlayerOcrResults enable or disable ocr results in the overlayer
 * @property enableOverlayerBayId enable or disable bay ID in the overlayer
 * @property enableOverlayerSiteId enable or disable site ID in the overlayer
 * @property timeZone timezone to be used for overlayer date and time, set to null for the device
 * automatic timezone
 */
data class VrmOutputConfig(
    val id: Int = -1,
    val enabled: Boolean,
    val vrmType: VrmOutputType,

    // General VRM settings
    val endpoint: String = "",
    val apiKey: String = "",
    val siteId: String = "",
    val useRoiId: Boolean = false,
    val bayIdentifier: String = "",
    val confidenceThreshold: Float = 0f,
    val timeoutSeconds: Int = 1,
    val verifySsl: Boolean = false,

    // Overlayer
    val enableOverlayer: Boolean = false,
    val overlayerPosition: VrmOverlayerPosition = VrmOverlayerPosition.TOP_LEFT,
    val overlayerLabel: String? = null,
    val enableOverlayerOcrResults: Boolean = false,
    val enableOverlayerBayId: Boolean = false,
    val enableOverlayerSiteId: Boolean = false,
    val timeZone: String? = null
)